const Dashboard = () => <div>Merchant Dashboard</div>

export default Dashboard
